import { createFeatureSelector, createSelector } from "@ngrx/store";
import { featureKey, State } from "./state";

const selectState = createFeatureSelector<State>(featureKey);

export const selectPrograms = createSelector(
  selectState,
  (state) => state.programs
);

export const selectLastEditDate = createSelector(
  selectState,
  (state) => state.lastEditDate
);

export const selectIsLoading = createSelector(
  selectState,
  (state) => state.isLoading
);

export const selectError = createSelector(selectState, (state) => state.error);
